(function () {
	// Immediately capture original console methods
	const originalMethods = {
		log: window.console?.log?.bind(console) || function () {},
		warn: window.console?.warn?.bind(console) || function () {},
		error: window.console?.error?.bind(console) || function () {},
	};

	const suppressErrorPatterns = [
		/shop_events_listener/i,
		/updateShopifyCustomerPrivacy/i,
		/updateThirdPartyConsentState/i,
		/fetch/i,
		/O\.e\.fetch/i,
		/e\.fetch/i,
		/gfv\d+herobanner\.js/i,
		/gfv\d+countdown\.js/i,
		/gfv\d+product\.js/i,
		/\$module\.gfV2HeroBanner is not a function/i,
		/Uncaught TypeError: GEMVENDOR.loadLibs is not a function/i,
		/Uncaught TypeError: \$module\.gfV1Countdown is not a function/i,
		/Uncaught TypeError: \$module\.gfV2HeroBanner is not a function/i,
		/Uncaught TypeError: \$module\.gfV3Product is not a function/i,
		/isImmediatePropagationStopped.*not.*function/i,
		/GorgiasChat*/i,
		/Gorgias Chat */i,
		/graphql\.json/i,
		/setTrackingConsent/i,
		/\[Klaviyo \/ Onsite\]/i,
		/\[GORGIAS-CHAT\]/i,
		/^\[Klaviyo\]/i,
		/\[HotReload\]/i,
		/\[TikTok Pixel\]/i,
		/was preloaded using link preload but not used within a few seconds/i,
		/Uncaught ReferenceError: GorgiasChat is not defined/i,
		/AbortError: signal is aborted without reason/i,
	];

	function shouldSuppressError(message, source) {
		try {
			return suppressErrorPatterns.some(
				(pattern) =>
					pattern.test(message) || (source && pattern.test(source))
			);
		} catch {
			return false;
		}
	}

	// Override console methods
	console.log = function (...args) {
		const message = args.join(" ");
		if (!shouldSuppressError(message)) {
			originalMethods.log.apply(console, args);
		}
	};

	console.warn = function (...args) {
		const message = args.join(" ");
		if (!shouldSuppressError(message)) {
			originalMethods.warn.apply(console, args);
		}
	};

	console.error = function (...args) {
		const message = args.join(" ");
		if (!shouldSuppressError(message)) {
			originalMethods.error.apply(console, args);
		}
	};

	// Error event handlers
	window.onerror = function (message, source) {
		return shouldSuppressError(message, source);
	};

	window.addEventListener(
		"error",
		function (event) {
			if (shouldSuppressError(event.message, event.filename)) {
				event.preventDefault();
			}
		},
		true
	);

	window.addEventListener("unhandledrejection", function (event) {
		if (
			event.reason &&
			shouldSuppressError(event.reason.message, event.reason.stack)
		) {
			event.preventDefault();
		}
	});
})();
